import { ELocaleCode } from '@core/modules/intl/domain/enums';

export const venueCreateViewI18n = {
	[ELocaleCode.RU_RU]: {
		venueName: 'Название',
		required: 'Обязательно',
		add: 'Добавить',
		category: 'Категория',
	},
	[ELocaleCode.EN_US]: {
		venueName: 'Name',
		required: 'Required',
		add: 'Add',
		category: 'Category',
	},
};
